export default {
	request_error(state, boolean) {
		state.request_error = boolean
	},
	request_error_text(state, error_text) {
		state.request_error_text = error_text
	},
	is_login(state, is_login) {
		state.is_login = is_login
	},
	show_login(state, show_login) {
		state.show_login = show_login
	},
	base_info(state, base_info) {
		state.base_info = base_info
	}
}


// WEBPACK FOOTER //
// ./src/store/mutations.js